import { connect } from 'react-redux'
import { selectCurrentTicket } from 'selectors/tickets'
import { updateCustomer } from 'actions/customers'
import {
  doStartEditing,
  doStopEditing,
  selectIsEditing,
  doCopyCustomerEmail,
  doCopyCustomerWebsite,
} from 'ducks/inAppCards/customer'
import { selectCustomer } from 'selectors/customers'

import View from './view'

const select = state => {
  const ticket = selectCurrentTicket(state)
  return {
    currentTicketId: ticket.id,
    customer: selectCustomer(state, ticket.customerId),
    isEditing: selectIsEditing(state),
  }
}

const perform = {
  openEditForm: doStartEditing,
  closeEditForm: doStopEditing,
  onEditSave: updateCustomer,
  doCopyCustomerEmail,
  doCopyCustomerWebsite,
}

export default connect(select, perform)(View)
